module.exports = __webpack_public_path__ + "img/union-pay.cac48532.png";